<template>
  <div class="pbr-index-map-table-container" style="overflow:auto">
    <el-table ref="table"
              :key="height"
              class="pbr-home-filter-project-table"
              :data="dataList"
              size="mini"
              :border="true"
              :height="height"
              :max-height="height"
              v-el-table-infinite-scroll="loadMore"
              :infinite-scroll-disabled="infiniteScrollDisabled"
              :infinite-scroll-delay="1000"
              @cell-click="goto"
              row-class-name="row-style"
              :header-cell-style="{'text-align':'center'}"
              >
              <template v-for="(column,index) in columns">
                <el-table-column v-if="column.slot"  :key="index" :label="column.label"
                                 :width="column.width">
                  <template slot-scope="scope">
                   <template v-if="column.slot === 'img'">
<!--                     <img src="http://dev.bfront.xhsl.xhszjs.cn/中国.png" alt="logo" style="width: 28px" />-->
<!--                     ${$pbrApis.baseUrl}-->
                     <img v-if="scope.row[column.name]" :src="`${scope.row[column.name]}`" alt="logo" style="width: 28px; border: 1px solid #EEEEEE;">
                   </template>
                  </template>
                </el-table-column>
                <el-table-column v-else :key="index" :label="column.label"
                       :prop="column.name"
                       show-overflow-tooltip
                       :width="column.width">
                </el-table-column>
              </template>
      <div slot="append"
           style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 25px;
                  ">
        {{ tableMoreDesc }}
      </div>
    </el-table>
  </div>
</template>

<script>
import elTableInfiniteScroll from 'el-table-infinite-scroll'
export default {
  name: 'pbrMapTable',
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  props: {
    map:{
      type:Object
    },
    height: {
      type: [String, Number],
      default: 400
    },
    url: {
      type: String,
      default: '/front/home/ginfos'
    },
    currentModule: {
      type: String,
      default: 'xm'
    },
    params:{
      type: Object,
      default: ()=>{}
    },
    columns: {
      type: Array,
      default: () => {
        return [
          {
            name: 'name',
            label: '名称',
            width: 'auto'
          }
        ]
      }
    }
  },
  data () {
    return {
      infiniteScrollDisabled: false, // 异步加载切换,
      dataList: [],
      currentPage: 0,
      pageSize: 15,
      tableMoreDesc: this.$t('loading')
    }
  },
  computed: {
    routerName () {
      let routers = {
        'xm': 'pbrProjectDetail',
        'sj': 'pbrInfoDetail',
        'fx': 'pbrRiskDetail'
      }
      return routers[this.currentModule]
    }
  },
  methods: {
    /**
     * 根据module获取相应列表信息
     *
     * @param module: xm, sj, fx
     * @param from
     */
    loadTableData (module = 'xm', from = 'cn') {
      this.module = module
      let self = this
      // this.$pbrApis.requestByUrl(this.url, {
      this.$pbrApis.fetchMapTableInfos({
        from: from,
        ...this.params,
        module: module,
        pagesize: this.pageSize,
        currentpage: this.currentPage
      })
        .then((res) => {
          if (res.code === 200) {
            // this.dataList = res.result.models
            this.dataList = this.dataList.concat(res.result.models)
            if(!res.result.models || res.result.models.length === 0 || !(res.result.pageRows > this.currentPage)){
              this.tableMoreDesc = this.$t('noMoreData')
            }
          } else {
            self.listData = []
          }
        })
        .catch((error) => {
          self.listData = []
          console.error(error)
        })
    },
    /**
    * 加载更多
    */
    loadMore () {
      // if (this.dataList.length < this.pageSize || this.dataList.length < this.pageSize * this.currentPage) {
      //   debugger
      //   this.infiniteScrollDisabled = true
      //   this.tableMoreDesc = this.$t('noMoreData')
      //   return
      // }
      this.currentPage += 1
      this.tableMoreDesc = this.$t('loading')
      this.loadTableData(this.module)
    },
    goto (row, column, cell, event) {
      this.$router.push({name: this.routerName,
        params: row,
        query: {
          key: row.id
        }})
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {
    height: {
      handler (newValue, oldValue) {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      },
      immediate: true
    },
    currentModule: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.currentPage = 1
          this.pageSize = 15
          this.loadTableData(newValue)
          this.dataList = []
        }
      },
      immediate: true
    },
    params:{
      handler (newValue, oldValue) {
        if (newValue) {
          this.currentPage = 1
          this.pageSize = 15
          this.dataList = []
          this.loadTableData(this.currentModule)

        }
      },
    }
  },
  filters: {

  }
}
</script>

<style scoped>
/* ::v-deep 不起作用 */
 /deep/ .el-table__row.row-style{
  cursor: pointer;
   -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
>>> th.el-table__cell:first-child, >>> td.el-table__cell:first-child{
    border-bottom: none;
}
</style>
